/**
 * プレビュー - 申請作成画面のプレビュー
 * DynamicFormを使用して旧画面と同じUIを表示
 */

import { useState, useMemo } from 'react'
import type { BuilderState } from '../../types/formBuilder'
import { DynamicForm } from '../form/DynamicForm'
import { generateFormSchema, generateUiSchema } from '../../services/formBuilder'

interface PreviewProps {
  builderState: BuilderState
}

export function Preview({ builderState }: PreviewProps) {
  const [formData, setFormData] = useState<Record<string, any>>({})

  // builderStateからschemaとuiConfigを生成
  const schema = useMemo(() => {
    try {
      const schemaString = generateFormSchema(builderState)
      return JSON.parse(schemaString)
    } catch (error) {
      console.error('Schema generation error:', error)
      return { type: 'object', properties: {} }
    }
  }, [builderState])

  const uiConfig = useMemo(() => {
    try {
      const uiSchemaString = generateUiSchema(builderState)
      return JSON.parse(uiSchemaString)
    } catch (error) {
      console.error('UI schema generation error:', error)
      return {}
    }
  }, [builderState])

  if (builderState.fields.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
        <p className="text-gray-500 text-sm">
          フィールドを追加するとプレビューが表示されます
        </p>
      </div>
    )
  }

  const handleSubmit = (data: any) => {
    console.log('Preview form submitted:', data)
    alert('プレビューモードのため、実際の申請は行われません')
  }

  const handleCancel = () => {
    console.log('Preview form cancelled')
  }

  return (
    <div className="space-y-6">
      <DynamicForm
        schema={schema}
        uiConfig={uiConfig}
        formData={formData}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  )
}
